/**
 * Stop-Go lamp - three chambers for stop, go and prepare
 * second chamber is green for go signal
 * third chamber is red for stop signal
 * first chamber is cross and third chamber is stop when prepare1
 * first chamber is cross and second chamber green when prepare2
 * - used in Charleroi
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'

export default class ChaSgThreeChambersPrepare extends Element {
  setDefaultShapes () {
    const cross = new Konva.Group({
      name: 'cross',
      x: 0,
      y: 0,
      visible: false
    })

    const crossLineA = new Ren.Line({
      points: [5, 5, 25, 25],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 2
    })

    const crossLineB = new Ren.Line({
      points: [25, 5, 5, 25],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 2
    })

    cross.add(crossLineA)
    cross.add(crossLineB)

    this.shapes.push(
      new Ren.Rect({
        name: '',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Rect({
        name: '',
        x: 0,
        y: 30,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Rect({
        name: '',
        x: 0,
        y: 60,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'stopSignal',
        x: 15,
        y: 45,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'goSignal',
        x: 15,
        y: 75,
        radius: 15,
        fill: Color.offlineGray
      }),

      cross,

      // signalling foor
      new Ren.Line({
        points: [15, 90, 15, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 110, 30, 110],
        strokeWidth: 2,
        opacity: 0.8
      })
    )
  }

  turnOffAll () {
    this.modifyShape('goSignal', 'fill', Color.offlineGray)
    this.modifyShape('stopSignal', 'fill', Color.offlineGray)
    this.modifyShape('cross', 'visible', false)
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    // 3 = stop
    // 4 = prepare1
    // 5 = prepare2
    // 6 = go straight
    // 7 = go left
    // 8 = go right

    if (status.signalStop === 1) {
      this.turnOffAll()
      this.modifyShape('stopSignal', 'fill', 'red')
    } else if (status.signalGoStraight === 1 || status.signalGoLeft === 1 || status.signalGoRight === 1) {
      this.turnOffAll()
      this.modifyShape('goSignal', 'fill', 'green')
    } else if (status.signalPrepare === 1) {
      this.turnOffAll()
      this.modifyShape('stopSignal', 'fill', 'red')
      this.modifyShape('cross', 'visible', true)
    } else if (status.signalPrepare2 === 1) {
      this.turnOffAll()
      this.modifyShape('stopSignal', 'fill', 'red')
      this.modifyShape('cross', 'visible', true)
    } else {
      this.turnOffAll()
    }
  }
}
